export const premiumLandingUrl = 'https://info.thehotelsnetwork.com/en/benchdirect-pro?utm_source=BDtool&utm_medium=BDupsell&utm_campaign=upselling_BDpremium';
export const benchDirectLandingUrl = 'https://www.thehotelsnetwork.com/en/benchdirect/';
